import React from 'react';
import { ui } from '../../../config/uiSizes';

interface SelectedResourcesTableHeaderProps {
  typeSearch: string;
  onSetTypeSearchChange: (value: string) => void;
  nameSearch: string;
  onSetNameSearchChange: (value: string) => void;
}

export const SelectedResourcesTableHeader: React.FC<SelectedResourcesTableHeaderProps> = ({
  typeSearch,
  onSetTypeSearchChange,
  nameSearch,
  onSetNameSearchChange
}) => {
  return (
    <>
      {/* Header row (sticky) */}
      <div className="bg-gray-50 dark:bg-gray-900 px-5 py-3 border-b border-gray-200 dark:border-gray-700">
        <div className="space-y-3">
          <h4 className={`${ui.text.label} font-bold text-gray-900 dark:text-gray-100`}>
            Selected Resources by Type
          </h4>
          <div className={`flex items-center ${ui.gap.md}`}>
            {/* Type Search */}
            <div className="relative flex-1">
              <input
                type="text"
                value={typeSearch}
                onChange={(e) => onSetTypeSearchChange(e.target.value)}
                placeholder="Search by resource type..."
                className={`w-full ${ui.input.sm} ${ui.text.label} border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
              {typeSearch && (
                <button
                  onClick={() => onSetTypeSearchChange('')}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}
            </div>
            {/* Name Search */}
            <div className="relative flex-1">
              <input
                type="text"
                value={nameSearch}
                onChange={(e) => onSetNameSearchChange(e.target.value)}
                placeholder="Search by resource name..."
                className={`w-full ${ui.input.sm} ${ui.text.label} border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
              {nameSearch && (
                <button
                  onClick={() => onSetNameSearchChange('')}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectedResourcesTableHeader;










